import { Textarea } from '@navozyme/uikit/dist/atoms/Textarea';

import SummaryDocument from './SummaryDocument';

import '../styles/summary.scss';

export const PortInstructionItem = ({
  title,
  subtitle,
  documents,
  instructionsText,
  emptyDocumentsMessage,
}) => {
  const getDocumentUuid = (document) =>
    document?.documentUid || document?.templateUid;

  return (
    <div className="summary-documents-block">
      {title ? (
        <label
          className={
            'document-type-title document-type-title_with-title-button textarea__label'
          }>
          {title}
        </label>
      ) : null}
      {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
      <Textarea
        name="instructionsText"
        id="instructionsText"
        sizeInput="large"
        defaultValue={instructionsText || ''}
        rows="10"
        disabled={true}
      />
      <div
        style={{
          padding: '10px',
        }}></div>
      {documents && documents.length > 0 ? (
        <div className="documents-block">
          {documents.map((document) => {
            return (
              <SummaryDocument
                key={getDocumentUuid(document)}
                document={document}
              />
            );
          })}
        </div>
      ) : (
        <p>{emptyDocumentsMessage}</p>
      )}
    </div>
  );
};
